export default function IconTick() {
  return (
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 12L10 17L20 7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
